import { render, staticRenderFns } from "./GameInstance.vue?vue&type=template&id=5405690d&scoped=true&"
import script from "./GameInstance.vue?vue&type=script&lang=js&"
export * from "./GameInstance.vue?vue&type=script&lang=js&"
import style0 from "./GameInstance.vue?vue&type=style&index=0&id=5405690d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5405690d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5405690d')) {
      api.createRecord('5405690d', component.options)
    } else {
      api.reload('5405690d', component.options)
    }
    module.hot.accept("./GameInstance.vue?vue&type=template&id=5405690d&scoped=true&", function () {
      api.rerender('5405690d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/leaderboard/campaign/components/GameInstance.vue"
export default component.exports